import React from "react";

function Home() {
  return (
    <div>
      <h2>Home Screen</h2>
    </div>
  );
}

export default Home;
